import { Component, Injector, OnInit } from '@angular/core';
import { BaseComponent } from 'src/app/shared/baseComponent';
import { saveAs } from 'file-saver';
import * as d3 from 'd3';

@Component({
  selector: 'app-beaconlog',
  templateUrl: './beaconlog.component.html',
  styleUrls: ['./beaconlog.component.css']
})
export class BeaconlogComponent extends BaseComponent implements OnInit {

  constructor(injector: Injector) { super(injector) }
  overview: any = []
  scenarios: any = []
  scenariooverview: any = []
  records: any = []
  scenarioid = 0
  showScenarioOverview = false
  showRecords = false
  organizations: any = []
  sortByOrg = false
  sortByDate = false
  sortByCount = false

  private data = [
    { "Framework": "Vue", "Stars": "166443", "Released": "2014" },
    { "Framework": "React", "Stars": "150793", "Released": "2013" },
    { "Framework": "Angular", "Stars": "62342", "Released": "2016" },
    { "Framework": "Backbone", "Stars": "27647", "Released": "2010" },
    { "Framework": "Ember", "Stars": "21471", "Released": "2011" },
    { "Framework": "Vue2", "Stars": "166443", "Released": "2014" },
    { "Framework": "React3", "Stars": "150793", "Released": "2013" },
    { "Framework": "Angular2", "Stars": "62342", "Released": "2016" },
    { "Framework": "Backbone3", "Stars": "27647", "Released": "2010" },
    { "Framework": "Ember3", "Stars": "21471", "Released": "2011" },
  ];
  private svg: any;
  private margin = 50;
  private width = 750 - (this.margin * 2);
  private height = 400 - (this.margin * 2);
  private minx = 0
  private maxx = 0
  private miny = 0
  private maxy = 0


  async ngOnInit() {
    this.loader.show()
    this.overview = await this.db.get('beaconlog', "getoverview")
    this.organizations = await this.db.get('organization', "getorganizations")
    this.scenarios = await this.db.get('scenario', "getscenarios")
    this.overview.forEach((o:any) =>{
      o.organizationname = "undefined"
      let scen = this.scenarios.find((x:any)=> x.id == o.scenarioId)
      if (scen != null){
        o.organizationname = this.lookup(scen.organizationId,this.organizations)
      }
    })
    this.loader.hide()
  }

  async getScenarioOverview(scenarioid: number) {
    this.loader.show()
    this.scenarioid = scenarioid
    this.scenariooverview = await this.db.get('beaconlog', "GetOverviewByScenarioId", { scenarioid: scenarioid })
    this.scenariooverview.forEach((s: any) => {
      s.date = new Date(s.startDay);
    })
    this.showScenarioOverview = true
    this.showRecords = false
    this.loader.hide()
  }

  async downloadSelect(o: any) {
    this.loader.show()
    let phoneinfos: any = []
    let bLoad = true;
    this.scenariooverview.forEach((so: any) => {
      if (so.phoneInfo == o.phoneInfo) phoneinfos.push(so.phoneInfo)
    });
    this.records = await this.db.post("beaconlog", "GetLogByScenAndPhoneInfos", phoneinfos, { scenarioid: this.scenarioid })
    this.showScenarioOverview = false
    this.showRecords = true
    this.loader.hide()
  }
  async downloadAbove(o: any) {
    this.loader.show()
    let phoneinfos: any = []
    let bLoad = true;
    this.scenariooverview.forEach((so: any) => {
      if (bLoad) phoneinfos.push(so.phoneInfo)
      if (so.phoneInfo == o.phoneInfo) bLoad = false
    });
    this.records = await this.db.post("beaconlog", "GetLogByScenAndPhoneInfos", phoneinfos, { scenarioid: this.scenarioid })
    this.showScenarioOverview = false
    this.showRecords = true
    this.loader.hide()
  }

  downloadFile(data: any) {
    data = this.records
    const replacer = (key: any, value: any) => value === null ? '' : value; // specify how you want to handle null values here
    const header = Object.keys(data[0]);
    let csv = data.map((row: any) => header.map(fieldName => JSON.stringify(row[fieldName], replacer)).join(','));
    csv.unshift(header.join(','));
    let csvArray = csv.join('\r\n');

    var blob = new Blob([csvArray], { type: 'text/csv' })
    saveAs(blob, "beaconlogs.csv");
  }

  deleteByScenarioId(overview: any) {
    this.confirm.show("Do you really want to delete all records from scenarion " + this.lookup(overview.scenarioId, this.scenarios),
      () => { this.deleteByScenarioIdExec(overview) },
      () => { this.toast.info("Ok, nothing to do.") })
  }

  async deleteByScenarioIdExec(overview: any) {
    await this.db.delete("beaconlog", "DeleteBeaconLogByScenario", { scenarioid: overview.scenarioId })
    this.overview = await this.db.get('beaconlog', "getoverview")
  }
  graph(phoneInfo: string) {
    this.data = []
    let start = this.records[0].millis 
    this.records.forEach((r: any, i: number) => {
      let sec = (r.millis - start) / 1000.0
      if (i == 0) {
        this.minx = sec
        this.maxx = sec
        this.miny = r.rssi
        this.maxy = r.rssi
      }
      if (r.phoneInfo == phoneInfo) {

        if (this.minx > sec) this.minx = sec
        if (this.maxx < sec) this.maxx = sec
        if (this.miny > r.rssi) this.miny = r.rssi
        if (this.maxy < r.rssi) this.maxy = r.rssi
        let d = { "Framework": "Vue", "Stars": r.rssi, "Released": sec.toString()}
        this.data.push(d)
      }
    })
    this.createSvg();
    this.drawPlot();
  }
  private createSvg(): void {
    this.svg = d3.select("figure#bar")
      .append("svg")
      .attr("width", this.width + (this.margin * 2))
      .attr("height", this.height + (this.margin * 2))
      .append("g")
      .attr("transform", "translate(" + this.margin + "," + this.margin + ")");
  }

  private drawPlot(): void {
    // Add X axis
    const x = d3.scaleLinear()
      .domain([this.minx, this.maxx])
      .range([0, this.width]);
    this.svg.append("g")
      .attr("transform", "translate(0," + this.height + ")")
      .call(d3.axisBottom(x).tickFormat(d3.format("d")));

    // Add Y axis
    const y = d3.scaleLinear()
      .domain([this.maxy, this.miny])
      .range([this.height, 0]);
    this.svg.append("g")
      .call(d3.axisLeft(y));

    
    // Add dots
    const dots = this.svg.append('g');
    dots.selectAll("dot")
      .data(this.data)
      .enter()
      .append("circle")
      .attr("cx", (d: any) => x(d.Released))
      .attr("cy", (d: any) => y(d.Stars))
      .attr("r", 7)
      .style("opacity", .5)
      .style("fill", "#69b3a2");

    // Add labels
    // dots.selectAll("text")
    //   .data(this.data)
    //   .enter()
    //   .append("text")
    //   .text((d:any) => d.Framework)
    //   .attr("x", (d:any) => x(d.Released))
    //   .attr("y", (d:any) => y(d.Stars))
  }
  sortBy(what:any){
    if (what == "organizationname"){
      this.sortByOrg = this.sortUpDown(this.overview , "organizationname", this.sortByOrg) 
    }
    if (what == "lastDate"){
      this.sortByDate = this.sortUpDown(this.overview , "lastDate", this.sortByDate) 
    }
    if (what == "count"){
      this.sortByCount = this.sortUpDown(this.overview , "count", this.sortByCount) 
    }
  }
}

